import React from "react";
import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../cervo.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'
import luxs from "assets/img/LUX_SALUDA.png";
import Headerbutton from "../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function stepCervoTwo(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} =props;

    const saveAndContinue = () => {
        history.push("/admin/dashboard")
    }
    return (

        <div className={"containerStartCervoTwo wrapper history"}>
            <div className={"insideCervo boxed"}>
                <Headerbutton  saveAndContinue={saveAndContinue}  />
            </div>
            <div className={"container-history boxed"}>
                <img className={"character character--lux"} src={luxs} alt={""} />
                <div className={"container-dialogue"}>
                    <div className={"dialogue-content-text"}>
                        <p className={"dialogue-text"}>
                            <strong>{t("hi")} {user.name ?? "" }!</strong>
                            <br/>
                            {t("cervo.presenta")}
                        </p>
                    </div>
                    <div className={"dialogue-buttons"}>
                        <div className="left margin-right-auto">
                            <Button
                              icon={<LeftOutlined />}
                              type={"link"}
                              onClick={() => props.goTo(1)}
                            >
                                {t("atras")}
                            </Button>
                        </div>
                        <div className="right">
                            <Button icon={<ArrowRightOutlined />}
                                    onClick={() => props.goTo(3)}
                                    type={"primary"}
                                    className="primaryButton"
                            >
                                {t("next")}
                            </Button>
                        </div>
                    </div>
                    <p className={"dialogue-name"}>
                        <strong>LUX</strong>
                    </p>
                </div>
            </div>

        </div>

    )
}

export default withTranslation()(stepCervoTwo);
